import { Ty } from '@cotera/era';
import { BaseModel, Watchable } from '../../actions/framework';

export const MAX_CSV_DATA_ROWS = 10_000;

export type CsvParseError = {
  t:
    | 'empty-csv-file'
    | 'exceeded-max-rows'
    | 'create-table-error'
    | 'parse-error'
    | 'staging-error';
};

type State =
  | {
      /**
       * Produce a file
       *
       * If parsing step raised errors, then we can return back to
       * this state with the specified errors.
       */
      t: 'await-upload';
      errors?: CsvParseError[];
    }
  | {
      /** Parse it into a header and data rows */
      t: 'parsing-file';
      file: File;
    }
  | {
      t: 'creating-table';
    }
  | {
      /** Verifying the table was created successfully */
      t: 'verifying-table';
      attempt: number;
    };

export class CsvUploadModel extends BaseModel {
  readonly state: Watchable<State> = Watchable.fromValue<State>({
    t: 'await-upload' as const,
    errors: undefined,
  });
  readonly headerRow: Watchable<string[]> = Watchable.fromValue<string[]>([]);
  readonly dataRows: Watchable<Ty.Scalar[][]> = Watchable.fromValue<
    Ty.Scalar[][]
  >([]);

  readonly tentativeFile: Watchable<File | null> =
    Watchable.fromValue<File | null>(null);

  constructor() {
    super('csv-upload');
  }

  reset() {
    this.state.set({
      t: 'await-upload' as const,
      errors: undefined,
    });
    this.headerRow.set([]);
    this.dataRows.set([]);
    this.tentativeFile.set(null);
  }
}
